var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 203,
    viewBox: "0 0 544 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.273 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.909 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.545 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.182 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.818 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.455 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.091 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.727 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.364 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 42.1343V202.134",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 42.1343H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 82.1343H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 122.134H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 162.134H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 202.134H512",
    stroke: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 85.8019C38.773 85.8019 42.3699 107.808 49.1429 107.808C55.9159 107.808 59.5127 115.143 66.2857 115.143C73.0587 115.143 76.6556 126.719 83.4286 126.719C90.2016 126.719 93.7984 136.805 100.571 136.805C107.344 136.805 110.941 143.853 117.714 143.853C124.487 143.853 128.084 113.653 134.857 113.653C141.63 113.653 145.227 147.578 152 147.578C158.773 147.578 162.37 155.429 169.143 155.429C175.916 155.429 179.513 154.111 186.286 154.111C193.059 154.111 196.656 78.352 203.429 78.352C210.202 78.352 213.798 85.2288 220.571 85.2288C227.344 85.2288 230.941 110.673 237.714 110.673C244.487 110.673 248.084 112.793 254.857 112.793C261.63 112.793 265.227 120.014 272 120.014C278.773 120.014 282.37 114.398 289.143 114.398C295.916 114.398 299.513 103.739 306.286 103.739C313.059 103.739 316.656 118.352 323.429 118.352C330.202 118.352 333.798 94.8563 340.571 94.8563C347.344 94.8563 350.941 117.836 357.714 117.836C364.487 117.836 368.084 82.1916 374.857 82.1916C381.63 82.1916 385.227 98.0655 392 98.0655C398.773 98.0655 402.37 86.3177 409.143 86.3177C415.916 86.3177 419.513 42.1343 426.286 42.1343C433.059 42.1343 436.656 106.49 443.429 106.49C450.202 106.49 453.798 68.438 460.571 68.438C467.344 68.438 470.941 111.934 477.714 111.934C484.487 111.934 488.084 78.1228 494.857 78.1228C501.63 78.1228 505.227 111.475 512 111.475V202.134H32V85.8019Z",
    fill: "url(#paint0_linear_78_2702)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_78_2702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 85.8019C38.773 85.8019 42.3699 107.808 49.1429 107.808C55.9159 107.808 59.5127 115.143 66.2857 115.143C73.0587 115.143 76.6556 126.719 83.4286 126.719C90.2016 126.719 93.7984 136.805 100.571 136.805C107.344 136.805 110.941 143.853 117.714 143.853C124.487 143.853 128.084 113.653 134.857 113.653C141.63 113.653 145.227 147.578 152 147.578C158.773 147.578 162.37 155.429 169.143 155.429C175.916 155.429 179.513 154.111 186.286 154.111C193.059 154.111 196.656 78.352 203.429 78.352C210.202 78.352 213.798 85.2288 220.571 85.2288C227.344 85.2288 230.941 110.673 237.714 110.673C244.487 110.673 248.084 112.793 254.857 112.793C261.63 112.793 265.227 120.014 272 120.014C278.773 120.014 282.37 114.398 289.143 114.398C295.916 114.398 299.513 103.739 306.286 103.739C313.059 103.739 316.656 118.352 323.429 118.352C330.202 118.352 333.798 94.8563 340.571 94.8563C347.344 94.8563 350.941 117.836 357.714 117.836C364.487 117.836 368.084 82.1916 374.857 82.1916C381.63 82.1916 385.227 98.0655 392 98.0655C398.773 98.0655 402.37 86.3177 409.143 86.3177C415.916 86.3177 419.513 42.1343 426.286 42.1343C433.059 42.1343 436.656 106.49 443.429 106.49C450.202 106.49 453.798 68.438 460.571 68.438C467.344 68.438 470.941 111.934 477.714 111.934C484.487 111.934 488.084 78.1228 494.857 78.1228C501.63 78.1228 505.227 111.475 512 111.475",
    stroke: "#9FFB00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_78_2702",
    x: -10,
    y: 0.134277,
    width: 564,
    height: 197.295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.984314 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_78_2702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_78_2702",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_2702",
    x1: 272,
    y1: 42.1343,
    x2: 272,
    y2: 202.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FFB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FFB00",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line1.a0dd3a9040aef18347f3a44f6943e6b2.svg";
export { ForwardRef as ReactComponent };